// src/hooks/useTicketId.js
import { useLocation, useParams } from 'react-router-dom';
import { PARAMS } from '../api/axiosConfig';

export default function useTicketId() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const ticketIdFromQuery = queryParams.get(PARAMS.TICKET_ID);
  const { ticketId: ticketIdFromPath = '' } = useParams();
  return ticketIdFromQuery || ticketIdFromPath || '';
}
